/** @format */

import React, { useState } from "react";
import { LI } from "../../../AbstractElements";
import ShortcodeModal from "../../../Pages/Shortcode";

export default function ShortCode() {
  return null;
}
